<div class="mc-style-list-current-style-label text-heavy-weight">Current styles</div>
<div *ngIf="!(selectionStyleCode$ | async)" class="mc-style-list-value"> {{selectedStyleName}} </div>
<div *ngIf="selectionStyleCode$ | async as code" class="mc-style-list-value mc-code-popover-scope mc-code-popover-anchor">
  <div (mouseenter)="showCodePopover(selectionStylePopover)" (mouseleave)="scheduleHideCodePopover(selectionStylePopover)"> {{selectedStyleName}} </div>
  <div #selectionStylePopover popover="manual" class="mc-code-popover-host" (mouseenter)="cancelHideCodePopover()" (mouseleave)="onPopoverHostMouseLeave($event, selectionStylePopover)" (click)="$event.stopPropagation()">
    <ng-container *ngTemplateOutlet="codePopoverTemplate; context: { $implicit: code }"></ng-container>
  </div>
</div>
<mat-divider [vertical]="false"></mat-divider>
<div class="mc-d-flex mc-flex-row mc-align-items-center mc-padding-normal">
  <span class="text-heavy-weight">Available styles</span>
  <span class="mc-fill-remaining-flex-space"></span>
  <button class="mc-button-small" [ngClass]="{ 'mc-bg-active-button': showStyleFilter }" mat-icon-button matTooltip="Style Filter" (click)="toggleStyleFilter()">
    <mat-icon fontSet="project-titan" fontIcon="icon-filter"></mat-icon>
  </button>
</div>
<mat-form-field *ngIf="showStyleFilter" class="mc-form-field mat-form-field-compact" mcColor="secondary" floatLabel="never">
  <input [(ngModel)]="styleFilterValue" matInput type="text" placeholder="Style Filter">
  <button matIconSuffix class="mc-button-small" mat-icon-button matTooltip="Clear Filter" (click)="resetStyleFilter()">
    <mat-icon fontSet="project-titan" fontIcon="icon-close"></mat-icon>
  </button>
</mat-form-field>

<mat-list role="list" class="mc-list-selectable" [attr.id]="previewStylesContainerId$ | async">
  <ng-container *ngIf="!readonly">
    <!-- Item to unwrap content of selected inline node -->
    <mat-list-item class="mc-border-radius-normal" [hidden]="!isUnwrapCommandAvailable" (click)="unwrapText()">
      <span>(text)</span>
    </mat-list-item>
    <!-- Item to reset class when a style is selected -->
    <mat-list-item class="mc-border-radius-normal" [hidden]="isTextSelection" (click)="resetClass()">
      <span>(reset class)</span>
    </mat-list-item>
  </ng-container>
  <!-- Items to apply style -->
  <ng-container *ngFor="let style of cssStyles; trackBy: trackById; index as i">
    <mat-list-item class="mc-border-radius-normal mc-preview-item mc-code-popover-scope mc-code-popover-anchor" [ngClass]="{ 'mc-list-item-selected': isSelectedStyle(style.name) }" [hidden]="isHiddenStyle(style.name)" (click)="selectStyle($event, style.name)" (mouseenter)="showCodePopover(codePopover)" (mouseleave)="scheduleHideCodePopover(codePopover)">
      <span class="mc-preview-tag-html">
        <span class="mc-preview-tag-body">
          <span matListItemLine class="mc-preview-tag" [class]="style.previewClasses">{{style.name}}</span>
        </span>
      </span>
      <div #codePopover [id]="'mc-css-style-list-popover-' + i" popover="manual" class="mc-code-popover-host" (mouseenter)="cancelHideCodePopover()" (mouseleave)="onPopoverHostMouseLeave($event, codePopover)" (click)="$event.stopPropagation()">
        <ng-container *ngTemplateOutlet="codePopoverTemplate; context: { $implicit: style.code }"></ng-container>
      </div>
    </mat-list-item>
  </ng-container>
</mat-list>

<ng-template #codePopoverTemplate let-code>
  <div class="mc-code-popover">
    <ng-container *ngFor="let block of code.variants; let first = first">
      <ng-container *ngIf="!first">{{'\n\n'}}</ng-container>
      <ng-container *ngTemplateOutlet="codeBlock; context: { $implicit: block }"></ng-container>
    </ng-container>
    <ng-container *ngIf="code.descendants.length">
      <ng-container *ngIf="code.variants.length">{{'\n\n'}}</ng-container>
      <span class="mc-code-popover-comment">/* Descendant rules */</span>
      <ng-container *ngFor="let block of code.descendants">
        {{'\n\n'}}<ng-container *ngTemplateOutlet="codeBlock; context: { $implicit: block }"></ng-container>
      </ng-container>
    </ng-container>
  </div>
</ng-template>

<ng-template #codeBlock let-block>
  <span class="mc-code-popover-selector">{{block.selector}}</span>
  <ng-container *ngIf="block.comment">{{'\n'}}<span class="mc-code-popover-comment">{{block.comment}}</span></ng-container>
  {{'\n'}}<span class="mc-code-popover-punct">{{ '{' }}</span>
  <ng-container *ngFor="let prop of block.properties">
    {{'\n'}}&nbsp;&nbsp;<span class="mc-code-popover-property">{{prop.name}}</span><span class="mc-code-popover-punct">: </span><span class="mc-code-popover-value">{{prop.value}}</span>
    <ng-container *ngIf="prop.important">
      <span class="mc-code-popover-punct"> !</span>
      <span class="mc-code-popover-important">important</span>
    </ng-container>
    <span class="mc-code-popover-punct">;</span>
  </ng-container>
  {{'\n'}}<span class="mc-code-popover-punct">{{ '}' }}</span>
</ng-template>